/**
 * Shown by ProtectedRoute instead of an automatic login when signing in again
 * would not help (jorigin/brewauth#139): either the backend is unreachable
 * (Retry re-probes the session) or automatic sign-in has bounced too often
 * (Sign in is an explicit, user-driven login).
 */
interface SessionUnavailablePanelProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

export default function SessionUnavailablePanel({
  message,
  actionLabel,
  onAction,
}: Readonly<SessionUnavailablePanelProps>) {
  return (
    <div className="flex flex-col items-center justify-center h-64 gap-4">
      <p className="cell-muted">{message}</p>
      <button type="button" className="app-btn app-btn-primary" onClick={onAction}>
        {actionLabel}
      </button>
    </div>
  );
}
